export default __webpack_public_path__ + "static/media/MastersDegree.2894600d.pdf";